import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../../loading/loading.service';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, Observable, of, startWith, switchMap, take, tap } from 'rxjs';
import { ContractService } from 'src/app/modules/services/contracts/contract.service';
import { OpenSnackbarService } from 'src/app/modules/services/snackBar/open-snackbar.service';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ConcessaoService } from 'src/app/modules/services/concessao/concessao.service';
import { SercretariasService } from 'src/app/modules/services/secretarias/sercretarias.service';
import * as moment from 'moment';
import { AlertComponent } from '../../alert/alert.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-form-contract',
  templateUrl: './form-contract.component.html',
  styleUrls: ['./form-contract.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormContractComponent implements OnInit {
  @ViewChild('intervenientes') intervenientesRef!: ElementRef;
  @ViewChild('documents') documentosRef!: ElementRef;
  @ViewChild('anotation') anotationRef!: ElementRef;
  @Input() isEditMode: boolean = false;
  form!: FormGroup;
  contractID!: string | null;
  contract: any;
  contractTypes: any[] = [];
  isOptionsMenuOpen = false;
  entitiesTypes: any[] = [];

  concessaoTypes: any[] = [
    {
      "id": "bb96780c-bff4-4add-939d-6b33151cde85",
      "nome": "Rodoviarios",
      "descricao": "Descrição do tipo da concessao."
    },
    {
      "id": "bb96780c-bff4-4add-939d-6b33151cde85",
      "nome": "hidroviarios",
      "descricao": "Descrição do tipo da concessao."
    },
    {
      "id": "bb96780c-bff4-4add-939d-6b33151cde85",
      "nome": "aeroviarios",
      "descricao": "Descrição do tipo da concessao."
    },

  ];
  entities: any[] = [];
  secretarias: any[] = [];
  intervenientesList: any[] = [];
  anotacoesList: any[] = [];
  panelOpenState: boolean = false;

  enableEficacia: boolean = false;
  openedModal: boolean = false;
  prorrogavelAte: string = '';
  vigencia: string = '';
  tipo: string = ''
  filterInterveniente = new FormControl();
  filteredIntervenienteOptions!: Observable<string[]>;
  date: any
  selectedEntitie: any;
  searchControl = new FormControl('', [Validators.required, this.customValidator()]);
  searchControlTipoEntidadeIntervenientes = new FormControl();
  searchControlEntidadeIntervenientes = new FormControl();
  searchControlContractType = new FormControl('', [Validators.required]);
  searchControlConcessionType = new FormControl('', [Validators.required]);
  searchControlIntervenientes = new FormControl();
  searchControlsecretary = new FormControl('', [Validators.required]);
  filteredOptions: any[] = [];
  filteredOptionsEntities: any[] = [];
  filteredOptionsTipoEntidadeIntervenientes: any[] = [];
  filteredOptionsEntidadeIntervenientes: any[] = [];
  filteredOptionsContractTypes: any[] = [];
  filteredOptionsConcessionTypes: any[] = [];
  filteredOptionsSecretarias: any[] = [];
  selectedOption: any;
  selectedOptionTipoEntidadeIntervenientes: any;
  selectedOptionEntidadeIntervenientes: any;
  selectedOptionContractType: any;
  selectedOptionConcessionType: any;
  selectedOptionEntitie: any;
  selectedOptionSecretary: any;
  tipoEntidade = '';
  EntidadesFilter = '';
  pageSize: number = 10;
  pageIndex: number = 0;
  totalPages: number = 0;
  totalElements: number = 0;
  sortState: any = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  dataSourceEntitieTable = new MatTableDataSource<any>([]);
  dataSourceIntervenientsTable = new MatTableDataSource<any>([]);
  pageIndexAnotation: number = 1;
  pageSizeAnotation: number = 10;
  totalPagesAnotation: number = 1;
  totalElementsAnotation: number = 0;
  linkBreads = [
    {
      title: 'Informações Gerais',
      link: 'InformacoesGerais'
    },
    {
      title: 'Intervenientes',
      link: 'intervenientes'
    },
    {
      title: 'Documentos',
      link: 'documents'
    },
    {
      title: 'Anotações',
      link: 'anotation'
    }
  ]

  isHidrovia: boolean = false;
  selectedLink: string = 'InformacoesGerais';
  @ViewChild('paginatorIntervenientes', { static: false }) paginatorIntervenientes!: MatPaginator;
  @ViewChild('paginatoranotation', { static: false }) paginatoranotation!: MatPaginator;
  @ViewChild('paginatorDocument', { static: false }) paginatorDocument!: MatPaginator;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private entitiesService: EntitiesService,
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private contractService: ContractService,
    private snackbarService: OpenSnackbarService,
    private concessionService: ConcessaoService,
    private secretariasServices: SercretariasService,
    private _snackBar: MatSnackBar,
    private modalCtrl: ModalController,
  ) {

    this.form = this.fb.group({
      idTipoConcessao: ['', Validators.required],
      idTipoContrato: ['', Validators.required],
      numeroContrato: ['', [Validators.required, Validators.maxLength(12)]],
      idEntidade: ['', Validators.required],
      idSecretaria: ['', Validators.required],
      valorTotal: ['', Validators.required],
      totalBasisDate: ['', Validators.required],
      valorCAPEX: ['', Validators.required],
      valorOPEX: ['', Validators.required],
      dataAssinatura: ['', Validators.required],
      dataPublicacao: ['', Validators.required],
      billingStartDate: [''],
      dataEficacia: ['', Validators.required],
      diasVigencia: ['', Validators.required],
      medida: ['', Validators.required],
      dataFinal: ['', Validators.required],
      prorrogavelAte: ['', Validators.required],
      medidaProrrogavelAte: ['', Validators.required],
      nomeContrato: ['', Validators.required],
      numeroEdital: ['', [Validators.required, Validators.minLength(8)]],
      status: [true, Validators.required],
    })
    this.form.addControl('searchControl', this.searchControl);
  }

  ngOnInit(): void {
    this.getConcessionarias();
    this.contract = {
      status: "cadastrando"
    }

    this.route.paramMap.subscribe((params) => {
      this.contractID = params.get('id');
      if (this.contractID) {
        this.isEditMode = true;
        this.onGetContract(this.contractID);
      }
    });

    this.filteredIntervenienteOptions = this.filterInterveniente.valueChanges.pipe(
      debounceTime(300),
      startWith(''),
      switchMap((value: any) => this._filter(value))
    );

    this.getAllData();

    this.form.get('idTipoConcessao')?.valueChanges.subscribe({
      next: (res: any) => {

        let tipoConcessao = this.concessaoTypes.find((e) => e.id === res);

        if (tipoConcessao?.nome === 'Hidroviarios') {
          this.isHidrovia = true;
        } else {
          this.isHidrovia = false;
        }
      }
    })


  this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' && value.trim().length > 0),
      switchMap(value =>
        this.entitiesService.getEntities(0, 'asc', 'razaoSocial', 'Concessionária', value?.trim(), value?.trim(), 'true').pipe(
          catchError(() => of([])) // Retorna uma lista vazia caso haja erro na busca
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptions = results.content || [];
    });

    this.searchControlIntervenientes.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value),
      switchMap(value => this.entitiesService.getEntities(0, 'asc', 'razaoSocial', 'Concessionária', value, value).pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsEntities = results.content
    });
    this.searchControlTipoEntidadeIntervenientes.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value),
      switchMap(value => this.entitiesService.getEntitiesTypes().pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsTipoEntidadeIntervenientes = results
    });
    this.searchControlEntidadeIntervenientes.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(), filter(value => value),
      switchMap(value => this.entitiesService.getEntities(0, 'asc', 'razaoSocial', 'Concessionária', value, value).pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsEntidadeIntervenientes = results.content
    });
    this.searchControlContractType.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' && value?.trim().length > 0),
      switchMap(value => this.contractService.getContractType().pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsContractTypes = results
    });
    this.searchControlConcessionType.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' && value?.trim().length > 0),
      switchMap(value => this.concessionService.getConcessionTypes().pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsConcessionTypes = results.content
    });
    this.searchControlsecretary.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' && value?.trim().length > 0),
      switchMap(value => this.secretariasServices.getSecretarias().pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsSecretarias = results
    });

    this.filteredOptionsContractTypes = this.contractTypes;
    this.filteredOptionsConcessionTypes = this.concessaoTypes;
  }


  onBreadcrumbClick(section: string) {
    this.selectedLink = section;
  }

  onOpen() {
    if (!this.filteredOptions) {
      this.entitiesService.getEntities(0, 'asc', 'razaoSocial', 'Concessionária').subscribe({
        next: (res: any) => {
          this.filteredOptions = res.content;
        }, error: (err: any) => {
          this.snackbarService.openSnackBar(err.message, 'error')
        }
      });
    }
  }
  getConcessionarias(){
    this.entitiesService.getEntities(0, 'asc', 'razaoSocial', 'Concessionária', '', '', 'true').subscribe((resp:any)=>{
    this.filteredOptions = resp.content;
  })

  }
  onSubmit(action: string) {
    let formValue = this.form.value;

    formValue.dataAssinatura = moment(formValue.dataAssinatura).format('YYYY-MM-DD');
    formValue.dataPublicacao = formValue.dataPublicacao ? moment(formValue.dataPublicacao).format('YYYY-MM-DD') : null;
    formValue.billingStartDate =  formValue.billingStartDate ? moment(formValue.billingStartDate).format('YYYY-MM-DD') : null;
    formValue.dataEficacia = formValue.dataEficacia ? moment(formValue.dataEficacia).format('YYYY-MM-DD') : null;
    formValue.intervenientes = this.intervenientesList || [];
    formValue.anotacoes = this.anotacoesList || [];

    const jsonPayload = {
      id: this.contract.id || null,
      contractTypeId: formValue.idTipoContrato || null,
      concessionTypeId: formValue.idTipoConcessao || null,
      contractNumber: formValue.numeroContrato || null,
      companyId: formValue.idEntidade || null,
      secretaryId: formValue.idSecretaria || null,
      totalValue: formValue.valorTotal ? this.convertToNumber(formValue.valorTotal) : null,
      capexValue: formValue.valorCAPEX ? this.convertToNumber(formValue.valorCAPEX) : null,
      opexValue: formValue.valorOPEX ? this.convertToNumber(formValue.valorOPEX) : null,
      signatureDate: formValue.dataAssinatura || null,
      dataPublicacao: formValue.dataPublicacao || null,
      billingStartDate:formValue.billingStartDate || null,
      effectivenessDate: formValue.dataEficacia || null,
      validityNumber: formValue.diasVigencia || null,
      measure: formValue.medida || null,
      endDate: formValue.dataFinal || null,
      extendableUntil: formValue.prorrogavelAte || null,
      measureExtendableUntil: formValue.medidaProrrogavelAte || null,
      contractName: formValue.nomeContrato || null,
      noticeNumber: formValue.numeroEdital || null,
      status: formValue.status || false,
      totalBasisDate: moment(formValue.totalBasisDate).format('YYYY-MM-DD'),
    };

    this.isEditMode ? this.handleEditSubmit(jsonPayload, action) : this.handleCreateSubmit(jsonPayload, action);
  }

  getAllData() {
    this.entitiesService.getEntities(0, 'asc', 'razaoSocial', 'Concessionária').subscribe({
      next: (res: any) => {
        this.entities = res.content;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    });

    this.entitiesService.getEntitiesTypes().subscribe({
      next: (res: any) => {
        this.entitiesTypes = res;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    })
    this.contractService.getContractType().subscribe({
      next: (res: any) => {
        this.contractTypes = res;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    })

    this.concessionService.getConcessionTypes().subscribe({
      next: (res: any) => {
        this.concessaoTypes = res.content;
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    })
    this.secretariasServices.getSecretarias().subscribe({
      next: (res: any) => {
        this.secretarias = res;
        this.form.patchValue({
          idSecretaria: this.secretarias[0].id
        })
      }, error: (err: any) => {
        this.snackbarService.openSnackBar(err.message, 'error')
      }
    })

  }

  handleEditSubmit(data: any, action: string) {
    this.contractService.updateContract(data, this.contractID).pipe(take(1),
      finalize(() => {
        this.loadingService.hideLoading()
      })).subscribe({
        next: (res: any) => {
          this.openSnackBar('Contrato editado com sucesso.', 'sucess');
          if(action == 'cad_and_continuous'){
            this.router.navigate([`contrato/${res.id}/detalhes`]);
          }else{
            this.router.navigate([`contratos`]);
          }

        }, error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable contract') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        }
      })
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  handleCreateSubmit(data: any, action: string) {
    this.contractService.createContract(data).pipe(take(1),
      finalize(() => {
        this.loadingService.hideLoading()
      })).subscribe({
        next: (res: any) => {
          this.openSnackBar("Contrato criado com sucesso!", 'sucess')
          if(action == 'cad_and_continuous'){
            this.router.navigate([`contrato/${res.id}`]);
          }else{
            this.router.navigate([`contratos`]);
          }

        }, error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            return this.openSnackBar(erro.error.message, 'error');
          }
          if (erro.error.error == 'Unprocessable Contract') {
            return this.openSnackBar(erro.error.message, 'warning');
          } else {
            return this.openSnackBar(
              'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
              'error'
            );
          }
        }
      })
  }
  //CALCULAR DATA FINAL
  calcFinalDate(e?: any, tipo?: any) {
    this.tipo = tipo;
    if (e?.value) {
      this.date = e?.value;
    }
    let infos;
    if (this.tipo == 'dataAssinatura' || !this.enableEficacia) {
      this.form.value.dataAssinatura = moment(this.date);
      infos = {
        signatureDate: moment(this.form.value.dataAssinatura),
        measure: this.form.value.medida,
        quantity: this.form.value.diasVigencia
      }
    } else if (this.tipo == 'dataEficacia' || this.enableEficacia) {
      this.form.value.dataEficacia = moment(this.date);
      infos = {
        effectivenessDate: moment(this.form.value.dataEficacia),
        measure: this.form.value.medida,
        quantity: this.form.value.diasVigencia
      }
    }


    if ((this.form.get('dataEficacia')?.value && this.form.get('diasVigencia')?.value && this.form.get('medida')?.value)
      || (this.form.get('dataAssinatura')?.value && this.form.get('diasVigencia')?.value && this.form.get('medida')?.value)) {

      this.contractService.calcFinalDate(infos).pipe(
        take(1),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (res: any) => {
          this.form.patchValue({
            dataFinal: res
          })
        }, error: (error: any) => {
          this.openSnackBar(error.error.message, 'error')
        }
      })
    }
  }

async viewstoryModal(contractId: string | null) {
    const data = {
      type: 'contract',
      id: contractId,
      fieldMappings: {
        contractType: 'Tipo de Contrato',
        concessionType: 'Tipo de Concessão',
        contractNumber: 'Número do Contrato',
        noticeNumber: 'Número do Edital',
        company: 'Entidade',
        secretary: 'Secretaria',
        contractName: 'Nome',
        totalValue: 'Valor Total',
        signatureDate: 'Data Assinatura',
        dataPublicacao: 'Data de Publicação',
        effectivenessDate: 'Data de Eficácia',
        capexValue: 'Valor Capex',
        opexValue: 'Valor Opex',
        validityNumber: 'Vigência',
        measure: 'Medida',
        endDate: 'Data Final',
        extendableUntil: 'Prorrogável até',
        measureExtendableUntil: 'Medida Prorrogação',
        totalBasisDate: 'Data Base Total',
        capexBasisDate: 'Data Base Capex',
        opexBasisDate: 'Data Base Opex',
        status:'Status'
      }
    }
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: {
        data: data,
        fieldMappings: data.fieldMappings,
      },
    });

    modal.present();
  }


  populateContract() {

    this.searchControlContractType.setValue(this.contract?.contractType?.name);
    this.searchControlConcessionType.setValue(this.contract?.concessionType?.name);
    this.searchControl.setValue(this.contract?.company?.razaoSocial);
    this.searchControlsecretary.setValue(this.contract?.secretary?.name);
    this.searchControlsecretary.setValue(this.contract.secretary.nomeFantasia, { emitEvent: false });
    this.form.get('idSecretaria')?.setValue(this.contract.secretary.id)
    this.form.patchValue({
      idTipoConcessao: this.contract.concessionType.id,
      idTipoContrato: this.contract.contractType.id,
      numeroContrato: this.contract.contractNumber,
      idEntidade: this.contract?.company.id,
      idSecretaria: this.contract?.secretary?.id,
      valorTotal: this.contract.totalValue ? this.formatarValorInicial(String(this.contract.totalValue)) : null,
      valorCAPEX: this.contract.capexValue ? this.formatarValorInicial(String(this.contract.capexValue)) : null,
      valorOPEX: this.contract.opexValue ? this.formatarValorInicial(String(this.contract.opexValue)) : null,
      dataAssinatura: this.contract.signatureDate,
      dataPublicacao: this.contract.dataPublicacao,
      billingStartDate: this.contract.billingStartDate,
      dataEficacia: this.contract.effectivenessDate,
      diasVigencia: this.contract.validityNumber,
      medida: this.contract?.measure,
      dataFinal: this.contract.endDate,
      prorrogavelAte: this.contract.extendableUntil,
      medidaProrrogavelAte: this.contract.measureExtendableUntil,
      nomeContrato: this.contract.contractName,
      numeroEdital: this.contract.noticeNumber,
      status: this.contract.status,
      totalBasisDate: this.contract.totalBasisDate,
    })

    if (this.contract.effectivenessDate) {
      this.enableDataEficacia()
    }
  }
  onGetContract(contractId: string) {
    this.contractService.getContract(contractId).pipe(
      take(1),
      finalize(() => {
        this.loadingService.hideLoading();
      })
    ).subscribe({
      next: (res: any) => {
        this.contract = res;

        this.populateContract()
      },
      error: (erro: any) => {
        if (erro.status !== 500 && erro.status) {
          return this.openSnackBar(erro.error.message, 'error');
        }
        if (erro.error.error == 'Unprocessable Entity') {
          return this.openSnackBar(erro.error.message, 'warning');
        } else {
          return this.openSnackBar(
            'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
            'error'
          );
        }
      }
    })
  }

  updatedIntervenientes() {

    const formatedInterveniente = {
      status: false,
      entidade: {
        id: this.selectedEntitie.id || null,
        tipoEntidade: this.selectedEntitie.tipoEntidade.nome,
        razaoSocial: this.selectedEntitie.razaoSocial,
        cnpj: this.selectedEntitie.cnpj,
      }
    }
    const hasEntity = this.intervenientesList.some(inter => inter.entidade.cnpj == formatedInterveniente.entidade.cnpj);

    if (!hasEntity) {
      this.intervenientesList.push(formatedInterveniente)
      this.dataSourceEntitieTable = new MatTableDataSource(this.intervenientesList);

      this.dataSourceEntitieTable.paginator = this.paginatorIntervenientes;
      this.pageSize = this.intervenientesList.length;
      this.pageIndex = 1;
      this.totalElements = 1;
    } else {
      this.openSnackBar(
        'Entidade duplicada! Entidade já foi adicionada.',
        'warning'
      );
    }

  }
  getStatusClass(statusContract: string) {
    switch (statusContract) {
      case 'cadastrando':
        return 'status-cadastrando';
      case 'aprovado':
        return 'status-aprovado';
      case 'rejeitado':
        return 'status-rejeitado';
      default:
        return 'status-desconhecido';
    }
  }

  enableDataEficacia() {
    this.enableEficacia = !this.enableEficacia;

    if (this.enableEficacia) {
      // Adiciona o validador required
      this.form.get('dataEficacia')?.setValidators(Validators.required);
    } else {
      // Remove o validador required
      this.form.get('dataEficacia')?.clearValidators();
    }

    // Atualiza a validade do campo após modificar os validadores
    this.form.get('dataEficacia')?.updateValueAndValidity();
  }

  back() {
    this.router.navigate(['/contratos']);
  }

  //select de intervenientes

  private _filter(value: string): Observable<string[]> {
    const filterValue = value?.toLowerCase();
    return of();
  }



  onOptionSelected(event: any) {
    const selectedOption = event.option.value;
    this.selectedOption = selectedOption;
    this.searchControl.setValue(selectedOption.razaoSocial, { emitEvent: false }); // Evita disparar valueChanges
    this.form.get('idEntidade')?.setValue(selectedOption.id);  // Define id conforme necessário
    if(this.isEditMode){this.contract.company.razaoSocial = selectedOption.razaoSocial}
    this.searchControl.updateValueAndValidity(); // Revalida o campo após seleção
    this.filteredOptions = [];
  }
  onOptionSelectedTipoEntidadeIntervenientes(event: any) {
    this.selectedOptionTipoEntidadeIntervenientes = event.option.value;


    this.searchControlTipoEntidadeIntervenientes.setValue(this.selectedOptionTipoEntidadeIntervenientes || '', { emitEvent: false });

    this.filteredOptionsTipoEntidadeIntervenientes = [];
    let newintervenientesList = []
    if (this.selectedOptionTipoEntidadeIntervenientes) {
      newintervenientesList = this.intervenientesList.filter(item => {

        return item.entidade.tipoEntidade?.toLowerCase().includes(this.selectedOptionTipoEntidadeIntervenientes?.toLowerCase())
      }
      );
    } else {

      newintervenientesList = [...this.intervenientesList];
    }


    this.dataSourceEntitieTable = new MatTableDataSource(newintervenientesList);
  }
  onOptionSelectedEntidadeIntervenientes(event: any) {
    this.selectedOptionEntidadeIntervenientes = event.option.value;


    this.searchControlEntidadeIntervenientes.setValue(this.selectedOptionEntidadeIntervenientes || '', { emitEvent: false });

    this.filteredOptionsEntidadeIntervenientes = [];
    let newintervenientesList = []
    if (this.selectedOptionEntidadeIntervenientes) {
      newintervenientesList = this.intervenientesList.filter(item => {

        return item.entidade.razaoSocial?.toLowerCase().includes(this.selectedOptionEntidadeIntervenientes?.toLowerCase())
      }
      );

    } else {

      newintervenientesList = [...this.intervenientesList];
    }


    this.dataSourceEntitieTable = new MatTableDataSource(newintervenientesList);
  }
  onOptionSelectedIntervenientes(event: any) {
    this.selectedOptionEntitie = event.option.value;

    this.searchControlIntervenientes.setValue(this.selectedOptionEntitie.razaoSocial, { emitEvent: false });
    this.selectedEntitie = this.selectedOptionEntitie
    this.filteredOptions = [];
  }

  selectEntitieType(entitieName: string) {
    this.tipoEntidade = entitieName;
  }
  selectEntitie(entitieName: string) {
    this.tipoEntidade = entitieName;
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove caracteres não numéricos, exceto vírgula
    value = value.replace(/[^0-9,]/g, '');

    // Substitui vírgula por ponto para tratamento de decimal
    value = value.replace(',', '.');

    // Limita a duas casas decimais
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('').substring(0, 2);
    } else if (parts.length === 2) {
      value = parts[0] + '.' + parts[1].substring(0, 2);
    }

    // Substitui ponto por vírgula para exibição
    input.value = value.replace('.', ',');
  }

  openOptionsMenu(event: any) {
    this.isOptionsMenuOpen = true;
  }
  changeStatus(status: string) {


  }

  onInactivateModalConfirm(id: any): void {
    this.loadingService.showLoading();

  }
  onActivateModalConfirm(id: any): void {
    this.loadingService.showLoading();

  }
  onFocusContractType() {
    this.filteredOptionsContractTypes = this.contractTypes;
  }


  onFocusConcessionType() {
    this.filteredOptionsConcessionTypes = this.concessaoTypes;
  }

  // Filtrar tipos de contrato
  filterContractTypes(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value?.toLowerCase();
    this.filteredOptionsContractTypes = this.contractTypes.filter(option =>
      option.nome?.toLowerCase().includes(filterValue)
    );
  }

  // Filtrar tipos de concessão
  filterConcessionTypes(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value?.toLowerCase();
    this.filteredOptionsConcessionTypes = this.concessaoTypes.filter(option =>
      option.nome?.toLowerCase().includes(filterValue)
    );
  }
  customValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value !== this.selectedOption?.razaoSocial && (this.selectedOption?.razaoSocial && value) ||
          value?.razaoSocial !== this.selectedOption?.razaoSocial && (this.selectedOption?.razaoSocial && value?.razaoSocial) ||
          value !== this.contract?.company?.razaoSocial && (this.contract?.company?.razaoSocial && value)) {
        // Define o idEntidade como null e retorna um erro de validação
        if(this.form){
          this.form.get('idEntidade')?.setValue(null);
          return { invalidOption: true };
        }else{
          return null
        }


      }
      return null;
    };
  }

  formatarNumero(event: Event, campo:any): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value.replace(/\D/g, ''); // Remove caracteres não numéricos

    if (valor.length > 7) {
      valor = valor.substring(0, 7); // Limita a entrada a 7 dígitos (3 para número e 4 para ano)
    }

    // Insere a barra (/) após o terceiro caractere
    if (valor.length > 3) {
      valor = `${valor.substring(0, 3)}/${valor.substring(3)}`;
    }

    input.value = valor; // Atualiza o valor no campo
    this.form.get(campo)?.setValue(valor); // Atualiza o FormControl
  }
  formatarValor(event: Event, campo:any): void {
    const input = event.target as HTMLInputElement;
    let valor = input.value;

    // Remove tudo que não seja número
    valor = valor.replace(/\D/g, '');
    if (valor.length > 2) {
      // Insere vírgula para as duas casas decimais
      valor = valor.slice(0, -2) + ',' + valor.slice(-2);
    }
    // Adiciona pontos como separadores de milhar
    valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // Atualiza o valor do campo e o FormControl
    input.value = valor;
    this.form.get(campo)?.setValue(valor);
  }
  formatarValorInicial(valor: string | number): string {
    if (!valor) {
      return '';
    }

    // Converte o número para string formatada
    let valorString = typeof valor === 'number' ? valor.toFixed(2) : valor;
    valorString = valorString.replace('.', ','); // Troca ponto por vírgula
    valorString = valorString.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Adiciona separadores de milhar
    return valorString;
  }

  convertToNumber(valor: string): number {
    if (!valor) {
      return 0; // Retorna 0 para valores vazios ou nulos
    }
    // Remove os pontos e substitui a vírgula por um ponto
    const valorSemFormatacao = valor.replace(/\./g, '').replace(',', '.');

    // Converte a string para número
    return Number(valorSemFormatacao);
  }
  preventNegative(event: KeyboardEvent) {
  if (event.key === '-' || event.key === 'Subtract') {
    event.preventDefault();
  }
}
preventNegativePaste(event: ClipboardEvent) {
  const pasted = event.clipboardData?.getData('text') ?? '';
  if (isNaN(Number(pasted)) || Number(pasted) < 0) {
    event.preventDefault();
  }
}

validatePositiveValue(event: Event, controlName: string) {
  const input = event.target as HTMLInputElement;
  let value = Number(input.value);
  if (value < 0 || isNaN(value)) {
    value = 0;
    input.value = '0';
  }
  this.form.get(controlName)?.setValue(value, { emitEvent: false });
}
}
